import { InputField } from './InputField';

export function NumberField(props) {
  return <InputField {...props} type="number" />;
}
